import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Hank from './Hank';

ReactDOM.render(<Hank/>, document.getElementById('root'));
